document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        if (!window?.article_slider?.swiperMainSlider?.length) {
            return;
        }
        const breakpointMd = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            slidesPerColumn: 2,
        };
        window.article_slider.swiperMainSlider.forEach((swiper) => {
            swiper.params.breakpoints[768] = {
                ...breakpointMd,
            };
            swiper.init();
            swiper.update();
        });
    }, 1);
});
